import React, { Component } from 'react'
import '../ProjectView/style.css'
import './style.css'
import {Link} from 'react-router-dom'
import 'font-awesome/css/font-awesome.min.css';

class DetailsButterfly extends Component {
  componentDidMount(){
    window.scrollTo(0, 0);
  }

  render(){
    return(
      <div>
        <div className="header withImage" style={{  backgroundImage: `url(${process.env.PUBLIC_URL + '/images/butterfly-wall.png'})` }}>
          <Link to='/'>
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
          </Link>
          <h3 className="date" style={{color: "#000"}}>Spring 2022</h3>
          <h1>KalIDEOscope - Digital Prototyping</h1>
          <h3>IDEO San Francisco • Digital Prototyping and Animation</h3>
        </div>
        <div className="main">
          <p className="summary">To commemorate the opening of the new IDEO SF office, 
          a few IDEOers from across the nation collaborated on a kinetic sculpture for our new lobby space.
          <br/>
          <br/>
          I worked with the incredible mechanical engineers and industrial designers to 
          prototype their ideas digitally. 
          Prototyping helped us hone on the concept of wall of 600+ Nitinol butterflies, as well as make decisions around aesthetic, formation, and animation. </p>
          
          <img src={process.env.PUBLIC_URL + '/images/unity-butterflies.gif'} />
          <p className="subtitle">Async Shareback on the Unity Simulation</p>
          <img src={process.env.PUBLIC_URL + '/images/wave.gif'} />
          <p className="subtitle">The Wall in Real Life </p>

          <h2>Initial Prototypes in After Effects</h2>
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterwall-test1.gif'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterwall-test3-risingwave.gif'} />
          <p className="subtitle">Initial After Effects Prototypes</p>

          <p>As the team was still deciding between multiple concepts, I took the butterfly concept and created a quick "tinker" prototype. 
            With only 24 hours to create a tinker prototype, I utilized After Effects Expressions to mimic what a wall over 400+ butterflies might look like. (spoiler alert: my poor MacBook's fans were going OFF!)
            </p>

          <h2>Prototype 2 in Blender</h2>
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/wall-black.png'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterfly-formation-12-daliAnimated.gif'} />

          <p>
            <br/>
            Once we decided to move forward with the butterfly concept, I recreated the design in Blender.
            Using Blender's Geometry Nodes, I was able to programmatically generate new patterns. We played around with many different patterns to decide what formats we might want to use for the wall design.
          </p>
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterfly-formation-1.png'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterfly-formation-2.png'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterfly-formation-3-bulge.png'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/butterfly-formation-5-bullseye.png'} />
          <p>
            <br/>
            In addition to using Geometry Nodes for creating different patterns, I also utilized it for animations. 
            This exploration helped to discover using the technique of mapping black-and-white videos to butterfly-motion. And although Blender worked for initial animation visualization, it had limitations around the speed at which butterflies opened as well as the accuracy of the mapping.
            To get a more accurate animation, I needed to be able to control each butterfly and limit the speed of opening and closing. For this, I needed to recreate it in Unity.
        </p>
          <h2>Butterfly Wall Format Tool in Figma</h2>
          <img src={process.env.PUBLIC_URL + '/images/figma-butterfly.gif'} />
          <p>
          <br/>

          Prior to entering Figma, we needed to decide what the final format of the butterfly wall would be.
          I created a Figma page for our lead designer to be able to easily hide and unhide butterflies (using Components and Auto Layout).
          After our lead designer finalized the design in Figma, we used the layer names to export the new design to a spreadsheet, 
          where the mechanical engineer could export the design to a CNC (which actually milled the wall), and where I  could export the design to be generated in Unity.
            
                 </p>
          <h2>Prototype 3 in Unity</h2>
          <img src={process.env.PUBLIC_URL + '/images/person-fixed.gif'} />
          <p className="subtitle">Initial After Effects Prototypes</p>

          <p>
          For a final level of fidelity, I recreated Kalideoscope in Unity. With the CSV generated from the Figma tool, I could have the script generate the wall.
          Then, I brought in black and white PNG sequences to map each butterfly to a pixel on the PNG sequence. Each butterfly was runnning its own script
          to mimic the exact speed that the physical Nitinol butterflies opened and closed.
          <br/>
          This allowed for us to test animations at a very quick rate, and also to see how the speed of the butterflies might effect how animations would look on the wall.
                 </p>

          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/ANGLES-Mar-02-2022 10-25-41.gif'} />
          <img className="halfImage"  src={process.env.PUBLIC_URL + '/images/ZOOM-Mar-02-2022 10-26-49.gif'} />


        
       
        
        </div>
      </div>
    )
  }
}

export default DetailsButterfly



// WEBPACK FOOTER //
// ./src/components/ProjectDetailPage/project-butterfly.js